<template>
  <main id="rtp__page-c">
    <ResetCard v-if="_flagShowResetCard" />

    <NotificationCard
      v-if="_flagShowRestoredPinCard"
      :card-icon="notification.retoredPassword.icon"
      :card-title="notification.retoredPassword.title"
      :card-subtitle="notification.retoredPassword.subtitle"
      :button-text="notification.retoredPassword.buttonText"
      :button-event="redirect"
    />

    <NotificationCard
      v-if="_flagShowExpiredLinkResetPinCard"
      :card-icon="notification.expiredLink.icon"
      :card-title="notification.expiredLink.title"
      :card-subtitle="notification.expiredLink.subtitle"
      :button-text="notification.expiredLink.buttonText"
      :button-event="resendEmail"
    />

    <ResentLinkCard
      v-if="_flagShowResentLinkResetPinCard"
      :card-icon="notification.reSentLink.icon"
      :card-title="notification.reSentLink.title"
      :card-subtitle="notification.reSentLink.subtitle"
      :email="email"
    />
  </main>
</template>

<script>
  import ResetCard from './components/reset-card';
  import NotificationCard from '@/views/authentication/components/notification-card';
  import ResentLinkCard from '@/views/authentication/components/resent-link-card';

  import resetPinMixin from '@/mixins/reset-pin';

  export default {
    name: 'ResetPin',
    components: {
      ResetCard,
      NotificationCard,
      ResentLinkCard
    },
    mixins: [resetPinMixin],
    data: () => ({
      notification: {
        retoredPassword: {
          icon: 'check',
          title: 'PIN restaurado',
          subtitle: 'Agora você pode acessar sua conta com o novo PIN criado',
          buttonText: 'Ir para MyInd'
        },
        expiredLink: {
          icon: 'alert',
          title: 'O Link Expirou',
          subtitle: 'Gere um novo link para restaurar seu PIN',
          buttonText: 'Gerar Novo Link'
        },
        reSentLink: {
          icon: 'check',
          title: 'Link enviado',
          subtitle: 'Enviamos um novo link para o e-mail'
        }
      },
      email: ''
    }),
    mounted() {
      this.checkToken();
    },
    destroyed() {
      this._clearResetPinStore();
    },
    methods: {
      redirect() {
        const hasUser = localStorage.getItem('userData');

        hasUser ? this.redirectToHomePage() : this.redirectToLoginPage();
      },
      redirectToHomePage() {
        this.$router.push({ name: 'home', params: { prefix: this._prefix } }).catch(() => {});
      },
      redirectToLoginPage() {
        this.$router.push({ name: 'login' }).catch(() => {});
      },
      async resendEmail() {
        this._showLoading();

        const { ip } = await fetch('https://api.ipify.org/?format=json')
          .then((res) => res.json())
          .catch(() => ({ ip: '' }));

        const path = `/api/${this._prefix}/pin/reset`;
        const payload = {
          email: this.email,
          ip
        };

        this.$http
          .post(path, payload)
          .then(() => {
            this._showResentLinkResetPinCard();
          })
          .catch(() => {})
          .finally(() => {
            this._hideLoading();
          });
      },
      checkToken() {
        const token = this.$router.currentRoute.params.token ?? '';
        const path = `/api/${this._prefix}/pin/check-link`;
        const payload = { code: token };

        this._showLoading();
        this.$http
          .post(path, payload)
          .then((response) => {
            const {
              data: { email }
            } = response;

            this.email = email;
            this._showResetCard();
          })
          .catch((error) => {
            const {
              response: {
                data: { email },
                status
              }
            } = error;

            if (status === 403 && !!email) {
              this.email = email;
              this._showExpiredLinkResetPinCard();
              return;
            }

            if (status === 403 && !email && !localStorage.getItem('userData')) {
              this.redirectToLoginPage();
              return;
            }

            if (status === 403 && !email && localStorage.getItem('userData')) {
              this.redirectToHomePage();
            }
          })
          .finally(() => {
            this._hideLoading();
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  #rtp__page-c {
    min-height: 100dvh;
    width: 100%;
    padding: 37px 18px;
    background-image: url('../../../assets/images/cubos.png');
    background-color: #362f2b;
    background-size: 175px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
